module.exports = __webpack_public_path__ + "static/media/zombiesbymert.fbf6cce2.png";